const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48.00004"
    },
    viewBox: "0 0 48 48.00004",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,8.65502c-8.47,0-15.34,6.87-15.34,15.3501c0,8.4699,6.87,15.3399,15.34,15.3399     s15.34-6.87,15.34-15.3399C39.34,15.52502,32.47,8.65502,24,8.65502z M32.18,19.81512c0,0-0.03,1.88-0.31,3.06     c-0.28,1.1699-1.22,4.44-4.02,6.7399c-2.8,2.3-6.22,2.8-8.16,2.67c-1.93-0.13-4.31-0.87-5.84-1.82c0,0,3.51,0.38,6.1-1.7599     c0,0-2.62,0.12-3.86-2.89c0,0,0.89,0.1599,1.86-0.11c0,0-3.3-0.6001-3.34-4.1501c0,0,1.08,0.53,1.88,0.48     c0,0-3.15-2.4099-1.23-5.5199c0,0,3.15,4.18,8.63,4.3399c-1.33-3.6699,4.63-7.1499,7.08-3.81c0,0,0.95-0.0299,2.69-0.9699     c0,0-0.42,1.3199-1.75,2.1999c0,0,1-0.0099,2.23-0.54C34.05,17.87512,33.3,19.02502,32.18,19.81512z",
    style: {
      fill: "#4AA0EC"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBadge);
export default __webpack_public_path__ + "static/media/twitter-badge.7649677bca96ea7bd48978a729854cb7.svg";
export { ForwardRef as ReactComponent };